import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store/vuex';
import axiosInstance from '@/service/axiosInstance';

import AppNewLayout from '@/layout-new/AppLayout.vue';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            // 세션이 있으면 바로 대시보드, 없으면 가드에서 로그인으로 이동
            redirect: '/new/dashboard'
        },
        {
            path: '/auth/login',
            name: 'login',
            component: () => import('@/views-new/pages/auth/Login.vue')
        },
        // publishing new
        {
            path: '/new',
            name: 'new-style',
            component: AppNewLayout,
            children: [
                // template 예제 목록
                {
                    path: 'template-ex',
                    name: 'templateExList',
                    component: () => import('@/views-new/template/TemplateList.vue')
                },
                {
                    path: 'template-filter',
                    name: 'templateFilter',
                    component: () => import('@/views-new/template/TemplateFilterList.vue')
                },
                {
                    path: 'template/write',
                    name: 'templateWrite',
                    component: () => import('@/views-new/template/TemplateWrite.vue')
                },
                {
                    path: 'template/detail',
                    name: 'templateDetail',
                    component: () => import('@/views-new/template/TemplateDetail.vue')
                },
                {
                    path: 'dashboard',
                    name: 'dashboard',
                    component: () => import('@/views-new/Dashboard.vue')
                },
                // 카메라 관리
                {
                    path: 'cameraMonitoring/CameraAllDepthList/:listType/:encoderSeq',
                    name: 'CameraAllDepthList',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam', 'partner'] // ✅ 기업 권한 추가
                    },
                    component: () => import('@/views-new/camera/CameraAllDepthList.vue')
                },
                {
                    path: 'cameraMonitoring/CameraDepthList/:listType/:encoderSeq',
                    name: 'CameraDepthList',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam', 'partner', 'client'] // ✅ 기업 권한 추가
                    },
                    component: () => import('@/views-new/camera/CameraDepthList.vue')
                },
                {
                    path: 'cameraMonitoring/all/:encoderSeq',
                    name: 'CameraAll',
                    meta: {
                        requiresAuth: true
                    },
                    component: () => import('@/views-new/camera/CameraAll.vue')
                },
                {
                    path: 'cameraMonitoring/list-new/:encoderSeq',
                    name: 'NewCameraList',
                    meta: {
                        requiresAuth: true
                    },
                    component: () => import('@/views-new/camera/CameraList.vue')
                },
                {
                    path: 'cameraMonitoring/monitoring/:seq',
                    name: 'CameraMonitoring',
                    component: () => import('@/views-new/camera/CameraMonitoring.vue')
                },
                {
                    path: 'cameraMonitoring/chart/:seq',
                    name: 'CameraChart',
                    component: () => import('@/views-new/camera/CameraChart.vue')
                },
                // 경고 목록
                {
                    path: 'alert/list',
                    name: 'NewAlertList',
                    component: () => import('@/views-new/alert/AlertList.vue')
                },
                // 기업 관리
                {
                    path: 'enterprise',
                    name: 'NewEnterpriseList',
                    component: () => import('@/views-new/enterprise/EnterpriseList.vue')
                },
                {
                    path: 'enterprise/detail/:encoderSeq',
                    name: 'NewEnterpriseDetail',
                    component: () => import('@/views-new/enterprise/EnterpriseDetail.vue')
                },
                {
                    path: 'enterprise/write',
                    name: 'NewEnterpriseWrite',
                    component: () => import('@/views-new/enterprise/EnterpriseWrite.vue')
                },
                {
                    path: 'enterprise/modify/:seq',
                    name: 'NewEnterpriseModify',
                    component: () => import('@/views-new/enterprise/EnterpriseWrite.vue')
                },
                // SMS 관리
                {
                    path: 'sms/enterprise',
                    name: 'NewEnterpriseSmsList',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        // partner는 의도적으로 제외: 실사용 고객은 client/site 구조만 사용 중이라 partner 하위 조회 UI는 아직 불필요.
                        // BE(EnterpriseMapper.enterpriseSmsList)는 partner 분기를 이미 지원하므로, 필요해지면 'partner' 추가만 하면 됨.
                        enterprise_roles: ['lksam', 'client'] // ✅ 기업 권한 추가
                    },
                    component: () => import('@/views-new/sms/EnterpriseSmsList.vue')
                },
                {
                    path: 'sms/:encoderSeq',
                    name: 'NewSmsUserList',
                    component: () => import('@/views-new/sms/SmsUserList.vue')
                },
                {
                    path: 'sms/edit/:encoderSeq',
                    name: 'NewSmsUserModify',
                    component: () => import('@/views-new/sms/SmsUserModify.vue')
                },
                {
                    path: 'user',
                    name: 'NewUserList',
                    component: () => import('@/views-new/user/UserList.vue')
                },
                {
                    path: 'user/write',
                    name: 'NewUserJoin',
                    component: () => import('@/views-new/user/UserJoin.vue')
                },
                {
                    path: 'user/detail/:seq',
                    name: 'NewUserView',
                    component: () => import('@/views-new/user/UserView.vue')
                },
                // 통계
                {
                    path: 'statistics/month/:encoderSeq',
                    name: 'NewReportMonth',
                    component: () => import('@/views-new/statistics/report-month/ReportMonthList.vue')
                },
                {
                    path: 'statistics/enterpriseList',
                    name: 'ReportEnterpriseList',
                    component: () => import('@/views-new/statistics/report-month/ReportEnterpriseList.vue')
                },
                {
                    path: 'statistics/reportPeriod',
                    name: 'ReportPeriod',
                    component: () => import('@/views-new/statistics/report-month/ReportPeriod.vue')
                },
                {
                    path: 'statistics/month/detail/:encoderSeq/:reportMonth',
                    name: 'NewReportMonthDetail',
                    component: () => import('@/views-new/statistics/report-month/ReportMonthDetail.vue')
                },
                {
                    path: 'statistics/period/detail/:guid',
                    name: 'NewReportPeriodDetail',
                    component: () => import('@/views-new/statistics/report-month/ReportMonthDetail.vue'),
                    props: (route) => ({ mode: 'period', guid: route.params.guid })
                },
                // 녹화 영상 다운로드
                {
                    path: 'videoDownload/VideoDownloadEnterpriseList',
                    name: 'NewVideoDownloadEnterpriseList',
                    component: () => import('@/views-new/videoDownload/VideoDownloadEnterpriseList.vue')
                },
                {
                    path: 'videoDownload/VideoDownloadSearchList/:encoderSeq',
                    name: 'VideoDownloadSearchList',
                    component: () => import('@/views-new/videoDownload/VideoDownloadSearchList.vue')
                },
                // SYMON-FDS
                {
                    path: 'symon-fds/download',
                    name: 'NewFdsDownload',
                    component: () => import('@/views-new/symon-fds/download/FdsDownload.vue')
                },
                //정보 관리(시리얼키,mqtt관리 등)
                {
                    path: 'information/serialKey/list',
                    name: 'SerialKeyList',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam'] // ✅ 기업 권한 추가
                    },
                    component: () => import('@/views-new/information/SerialKeyList.vue')
                },
                {
                    path: 'information/mqtt/cert/list',
                    name: 'MqttCertList',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam'] // ✅ 기업 권한 추가
                    },
                    component: () => import('@/views-new/information/MqttCertList.vue')
                },
                // 프로그램 관리
                {
                    path: 'symon-fds/program/manage',
                    name: 'ProgramList',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam'] // ✅ 기업 권한 추가
                    },
                    component: () => import('@/views-new/symon-fds/program-manage/ProgramList.vue')
                },
                {
                    path: 'symon-fds/program/ProgramJoin',
                    name: 'ProgramJoin',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam'], //✅ 기업 권한 추가
                        purpose: 'join'
                    },
                    component: () => import('@/views-new/symon-fds/program-manage/ProgramJoin.vue')
                },
                {
                    path: 'symon-fds/program/ProgramResourceList/:program_name',
                    name: 'ProgramResourceList',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam'] // ✅ 기업 권한 추가
                    },
                    component: () => import('@/views-new/symon-fds/program-manage/ProgramResourceList.vue')
                },
                {
                    path: 'symon-fds/program/ProgramResourceView/:program_name/:seq',
                    name: 'ProgramResourceView',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam'] // ✅ 기업 권한 추가
                    },
                    component: () => import('@/views-new/symon-fds/program-manage/ProgramResourceView.vue')
                },
                {
                    path: 'symon-fds/program/ProgramResourceJoin/:program_name',
                    name: 'ProgramResourceJoin',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam'], // ✅ 기업 권한 추가
                        purpose: 'join'
                    },
                    component: () => import('@/views-new/symon-fds/program-manage/ProgramResourceJoin.vue')
                },
                {
                    path: 'symon-fds/program/ProgramResourceModify/:program_name/:seq',
                    name: 'ProgramResourceModify',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam'],
                        purpose: 'modify'
                    },
                    component: () => import('@/views-new/symon-fds/program-manage/ProgramResourceJoin.vue')
                },
                {
                    path: 'symon-fds/manual/manage',
                    name: 'NewManualManage',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam'] // ✅ 기업 권한 추가
                    },
                    component: () => import('@/views-new/symon-fds/manual-manage/ManualList.vue')
                },
                {
                    path: 'symon-fds/manual/manage/version/:manual_name',
                    name: 'NewManualVersionList',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam'] // ✅ 기업 권한 추가
                    },
                    component: () => import('@/views-new/symon-fds/manual-manage/ManualVersionList.vue')
                },
                {
                    path: 'symon-fds/manual/manage/edit/:manual_name/:version',
                    name: 'NewManualModify',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam'] // ✅ 기업 권한 추가
                    },
                    component: () => import('@/views-new/symon-fds/manual-manage/ManualModify.vue')
                },
                {
                    path: 'symon-fds/manual',
                    name: 'NewManualSelectList',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user']
                    },
                    component: () => import('@/views-new/symon-fds/manual/ManualSelectList.vue')
                },
                {
                    path: 'symon-fds/manual/:manual_name',
                    name: 'NewManualView',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'] // ✅ 유저 권한
                    },
                    component: () => import('@/views-new/symon-fds/manual/ManualView.vue')
                },
                // 고객센터 - 공지사항
                {
                    path: 'customer/notice',
                    name: 'NewNoticeList',
                    component: () => import('@/views-new/customer/notice/NoticeList.vue')
                },
                {
                    path: 'customer/notice/detail',
                    name: 'NewNoticeDetail',
                    component: () => import('@/views-new/customer/notice/NoticeDetail.vue')
                },
                {
                    path: 'customer/notice/write',
                    name: 'NewNoticeWrite',
                    component: () => import('@/views-new/customer/notice/NoticeWrite.vue')
                },
                // 자주묻는질문
                {
                    path: 'customer/faq',
                    name: 'NewFaqList',
                    component: () => import('@/views-new/customer/faq/FaqList.vue')
                },
                {
                    path: 'customer/faq/detail',
                    name: 'NewFaqDetail',
                    component: () => import('@/views-new/customer/faq/FaqDetail.vue')
                },
                {
                    path: 'customer/faq/write',
                    name: 'NewFaqWrite',
                    component: () => import('@/views-new/customer/faq/FaqWrite.vue')
                },
                // 서비스 요청
                {
                    path: 'customer/service-request',
                    name: 'NewServiceRequestList',
                    component: () => import('@/views-new/customer/service-request/ServiceRequestList.vue')
                },
                {
                    path: 'customer/service-request/detail',
                    name: 'NewServiceRequestDetail',
                    component: () => import('@/views-new/customer/service-request/ServiceRequestDetail.vue')
                },
                {
                    path: 'customer/service-request/write',
                    name: 'NewServiceRequestWrite',
                    component: () => import('@/views-new/customer/service-request/ServiceRequestWrite.vue')
                },
                // 로그
                //정보 관리(시리얼키,mqtt관리 등)
                {
                    path: 'log/programUseLog/list',
                    name: 'ProgramUseLogList',
                    meta: {
                        requiresAuth: true,
                        roles: ['admin', 'user'], // ✅ 유저 권한
                        enterprise_roles: ['lksam'] // ✅ 기업 권한 추가
                    },
                    component: () => import('@/views-new/log/ProgramUseLogList.vue')
                },
                // 자료실
                {
                    path: 'customer/resource',
                    name: 'NewResourceList',
                    component: () => import('@/views-new/customer/resource/ResourceList.vue')
                },
                {
                    path: 'customer/resource/detail',
                    name: 'NewResourceDetail',
                    component: () => import('@/views-new/customer/resource/ResourceDetail.vue')
                },
                {
                    path: 'customer/resource/write',
                    name: 'NewResourceWrite',
                    component: () => import('@/views-new/customer/resource/ResourceWrite.vue')
                },
                // 나의 페이지
                {
                    path: 'my-page',
                    name: 'NewMyPage',
                    component: () => import('@/views-new/my-page/MyPage.vue')
                },
                {
                    path: 'my-page/edit',
                    name: 'NewMyPageEdit',
                    component: () => import('@/views-new/my-page/MyPageEdit.vue')
                },
                // ui-template
                {
                    path: 'ui-template/grid',
                    name: 'ui-grid',
                    component: () => import('@/views-new/ui-template/GridPage.vue')
                },
                {
                    path: 'ui-template/button',
                    name: 'ui-button',
                    component: () => import('@/views-new/ui-template/ButtonPage.vue')
                },
                {
                    path: 'ui-template/misc',
                    name: 'ui-misc',
                    component: () => import('@/views-new/ui-template/MiscPage.vue')
                },
                {
                    path: 'ui-template/input',
                    name: 'ui-input',
                    component: () => import('@/views-new/ui-template/InputPage.vue')
                },
                {
                    path: 'ui-template/form',
                    name: 'ui-form',
                    component: () => import('@/views-new/ui-template/FormPage.vue')
                },
                {
                    path: 'ui-template/toast',
                    name: 'ui-toast',
                    component: () => import('@/views-new/ui-template/ToastPage.vue')
                },
                {
                    path: 'ui-template/dialog',
                    name: 'ui-dialog',
                    component: () => import('@/views-new/ui-template/DialogPage.vue')
                },
                {
                    path: 'ui-template/table',
                    name: 'ui-table',
                    component: () => import('@/views-new/ui-template/TablePage.vue')
                },
                {
                    path: 'ui-template/paginator',
                    name: 'ui-paginator',
                    component: () => import('@/views-new/ui-template/PaginatorPage.vue')
                }
            ]
        },
        // 레포트 프린트 팝업
        {
            path: '/report-print',
            name: 'printReportPopup',
            component: () => import('@/views-new/statistics/report-month/ReportMonthPrint.vue')
        },
        // 메뉴얼 프린트 팝업
        {
            path: '/manual-print/:manual_name',
            name: 'printManualPopup',
            component: () => import('@/views-new/symon-fds/manual/ManualDocument.vue')
        },
        {
            path: '/sign-up',
            name: 'sign-up',
            component: () => import('@/views-new/sign-up/SignUp.vue')
        },
        {
            path: '/sign-up-complete',
            name: 'sign-up-complete',
            component: () => import('@/views-new/sign-up/SignUpComplete.vue')
        },
        {
            path: '/api/web/v1/event/alerteventmessage/:event_seq',
            name: 'alerteventmessage',
            component: () => import('@/views-new/alert/AlertEventMessage.vue')
        },
        {
            path: '/serialKey/SerialKeyJoin/:original_serial_key',
            name: 'legacySerialKeyJoin',
            meta: {
                requiresAuth: true,
                roles: ['admin', 'user'],
                enterprise_roles: ['lksam', 'partner', 'client', 'site']
            },
            component: () => import('@/views-new/serialKey/SerialKeyJoin.vue')
        },
        {
            path: '/api/web/v1/serialKey/SerialKeyJoin/:original_serial_key',
            name: 'serialKeyJoin',
            meta: {
                requiresAuth: true,
                roles: ['admin', 'user'], // ✅ 유저 권한
                enterprise_roles: ['lksam', 'partner', 'client', 'site'] // ✅ 기업 권한 추가
            },
            component: () => import('@/views-new/serialKey/SerialKeyJoin.vue')
        }
    ]
});

// =========================================================
// ✅ sessionCheck 메모리 캐싱 (과도한 서버 요청 방지)
// =========================================================
// let sessionCheckCache = {
//     data: null,
//     timestamp: 0,
//     ttl: 30000 // 캐시 유효 시간: 30초
// };

/**
 * sessionCheck API를 호출하되, 30초 내 재호출 시 캐시 응답을 반환합니다.
 * - axiosInstance interceptor의 NO_CACHE_PATTERNS(/sessionCheck)는 브라우저/프록시
 *   레벨 캐시를 방지하고, 이 함수는 JS 메모리 수준에서 불필요한 네트워크 요청을
 *   줄이는 별개의 레이어입니다.
 */
// function checkSessionWithCache() {
//     const now = Date.now();
//     const cacheValid = sessionCheckCache.data && now - sessionCheckCache.timestamp < sessionCheckCache.ttl;
//
//     if (cacheValid) {
//         // 캐시 유효: Promise로 감싸서 반환 (then/catch 체이닝 가능하도록)
//         return Promise.resolve({ data: sessionCheckCache.data });
//     }
//
//     return axiosInstance.get('/api/web/v1/common/sessionCheck', { withCredentials: true }).then((response) => {
//         sessionCheckCache.data = response.data;
//         sessionCheckCache.timestamp = Date.now();
//         return response;
//     });
// }

/**
 * sessionCheck 캐시를 즉시 무효화합니다.
 * vuex store의 logout action에서 window.invalidateSessionCache()로 호출됩니다.
 */
// function invalidateSessionCache() {
//     sessionCheckCache.data = null;
//     sessionCheckCache.timestamp = 0;
// }

// vuex logout action에서 호출 가능하도록 window에 등록
// if (typeof window !== 'undefined') {
//     window.invalidateSessionCache = invalidateSessionCache;
// }

// =========================================================
// ✅ 예외 경로 판단 헬퍼 (세션 체크 없이 접근 허용)
// =========================================================
function isPublicPath(path) {
    return path === '/' || path === '/syopt/enterprisejoin' || path === '/sign-up' || path === '/sign-up-complete' || path === '/report-print' || path.startsWith('/manual-print/') || /\/api\/web\/v1\/event\/alerteventmessage\/.*/.test(path);
}

// =========================================================
// ✅ 권한 체크 헬퍼
// =========================================================
function checkPermission(to, user) {
    if (!to.meta.requiresAuth) return { allowed: true };

    if (!user) {
        return { allowed: false, reason: 'noUser' };
    }

    if (user.enterprise_use_yn === 'N') {
        return { allowed: false, reason: 'notApproved' };
    }

    const userRoles = [user.user_role];
    const hasUserPermission = to.meta.roles ? to.meta.roles.some((role) => userRoles.includes(role)) : true;

    const hasEnterprisePermission = to.meta.enterprise_roles ? to.meta.enterprise_roles.includes(user.enterprise_role) : true;

    if (!hasUserPermission || !hasEnterprisePermission) {
        return { allowed: false, reason: 'forbidden' };
    }

    return { allowed: true };
}

// =========================================================
// ✅ beforeEach 가드 (단일 가드로 통합)
// =========================================================
router.beforeEach(async (to, from, next) => {
    // [1] dev 환경 swagger 통과
    // td 환경에서만 swagger를 Vue Router 통과시킨다.
    // local: BE에서 permitAll이라 원래 잘 됨
    // live: 기존대로 sessionCheck → 비로그인 시 /auth/login
    if ((to.path.startsWith('/swagger-ui') || to.path.startsWith('/v3/api-docs')) && import.meta.env.VITE_APP_ENV === 'dev') {
        return next();
    }

    // [2] ✅ CKEditor 파괴 — 세션 체크 전 동기적으로 즉시 실행 (old 코드 동작 보존)
    if (window.CKEDITOR) {
        Object.values(window.CKEDITOR.instances || {}).forEach((instance) => {
            instance.destroy(true).catch((err) => console.error(err));
        });
    }

    // ✨ Vuex에 저장된 로컬스토리지 유저 정보 확인 (API 호출 안 함)
    // const sessionUser = store.state.user;

    // [3] 로그인 페이지: 세션이 살아있으면 대시보드로 리다이렉트
    // if (to.path === '/auth/login') {
    //     checkSessionWithCache()
    //         .then((response) => {
    //             const sessionUser = response?.data?.userData;
    //             if (sessionUser) {
    //                 store.commit('setUser', sessionUser);
    //                 return next('/new/dashboard');
    //             }
    //             store.dispatch('logout');
    //             return next();
    //         })
    //         .catch(() => {
    //             store.dispatch('logout');
    //             return next();
    //         });
    //     return;
    // }
    
    // 인증 상태를 서버 세션 기준으로 보강한다.
    let sessionUser = store.state.user;
    if (!sessionUser && !isPublicPath(to.path)) {
        try {
            const serverSession = await store.dispatch('hydrateSessionUser');
            sessionUser = serverSession || null;
        } catch (error) {
            console.warn('세션 복원 실패:', error);
        }
    }

    if (to.path === '/auth/login') {
        if (sessionUser) {
            return next('/new/dashboard');
        }
        store.dispatch('logout');
        return next();
    }

    // [4] 세션 없이 접근 허용하는 예외 경로
    if (isPublicPath(to.path)) {
        return next();
    }

    // [5] 일반 페이지: 세션 체크 후 권한 검사
    // checkSessionWithCache()
    //     .then((response) => {
    //         const sessionUser = response?.data?.userData;
    //
    //         // ✨ [수정 1] 로그인 여부를 따지기 전에, 시리얼 키부터 무조건 세션에 저장합니다.
    //         const isNewPath = to.path.startsWith('/api/web/v1/serialKey/SerialKeyJoin');
    //         const isLegacyPath = to.path.startsWith('/serialKey/SerialKeyJoin');
    //
    //         if ((isNewPath || isLegacyPath) && to.params.original_serial_key) {
    //             sessionStorage.setItem('originalSerialKey', to.params.original_serial_key);
    //
    //             // 💡 [핵심 해결] 옛날 주소 + 로그인 상태에서 화면이 안 뜨는 문제 방지
    //             // 옛날 주소로 들어오면 아예 안전한 "신규 주소(serialKeyJoin)"로 강제 연결(Redirect)해 줍니다.
    //             if (isLegacyPath && sessionUser) {
    //                 return next({
    //                     name: 'serialKeyJoin',
    //                     params: { original_serial_key: to.params.original_serial_key }
    //                 });
    //             }
    //         }
    //
    //         // 200 응답이어도 userData 없으면 미인증 처리
    //         if (!sessionUser) {
    //             sessionStorage.setItem('preLoginRoute', to.fullPath);
    //             store.dispatch('logout');
    //             return next({ name: 'login' });
    //         }
    //
    //         // ✅ 수정 — 항상 서버 최신값으로 동기화
    //         store.commit('setUser', sessionUser);
    //         sessionStorage.setItem('preLoginRoute', to.fullPath);
    //
    //         // 권한 체크
    //         const { allowed, reason } = checkPermission(to, sessionUser);
    //
    //         if (!allowed) {
    //             if (reason === 'noUser') {
    //                 alert('로그인이 필요합니다.');
    //                 return next('/auth/login');
    //             }
    //             if (reason === 'notApproved') {
    //                 alert('인증 대기중인 기업회원입니다.');
    //                 return next('/auth/login');
    //             }
    //             if (reason === 'forbidden') {
    //                 alert('접근 권한이 없습니다.');
    //                 return next('/new/dashboard');
    //             }
    //         }
    //
    //         return next();
    //     })
    //     .catch((error) => {
    //         console.error('세션 검사 중 오류 발생:', error);
    //         sessionStorage.setItem('preLoginRoute', to.fullPath);
    //
    //         // 비로그인 상태의 최초 진입(예: 브라우저 재실행 후 미인증)은 무알림 처리,
    //         // 기존 로그인 흔적이 있을 때만 '세션 만료' 안내를 노출
    //         const hadUserState = !!store.state.user;
    //         const isUnauthorized = error?.response?.status === 401;
    //
    //         if (hadUserState && isUnauthorized) {
    //             alert('로그인 세션 시간이 만료되어 로그인 페이지로 이동합니다.');
    //         } else if (hadUserState && !isUnauthorized) {
    //             alert('일시적인 네트워크 오류로 로그인 상태를 확인할 수 없습니다. 다시 시도해 주세요.');
    //         }
    //
    //         store.dispatch('logout');
    //         return next({ name: 'login' });
    //     });
    // });
    const isNewPath = to.path.startsWith('/api/web/v1/serialKey/SerialKeyJoin');
    const isLegacyPath = to.path.startsWith('/serialKey/SerialKeyJoin');

    if ((isNewPath || isLegacyPath) && to.params.original_serial_key) {
        sessionStorage.setItem('originalSerialKey', to.params.original_serial_key);

        if (isLegacyPath && sessionUser) {
            return next({
                name: 'serialKeyJoin',
                params: { original_serial_key: to.params.original_serial_key }
            });
        }
    }

    // 유저 정보가 아예 없으면 즉시 로그인으로 보냄
    if (!sessionUser) {
        sessionStorage.setItem('preLoginRoute', to.fullPath);
        store.dispatch('logout');
        return next({ name: 'login' });
    }

    // 유저가 존재하면 권한 체크
    sessionStorage.setItem('preLoginRoute', to.fullPath);
    const { allowed, reason } = checkPermission(to, sessionUser);

    if (!allowed) {
        if (reason === 'notApproved') {
            alert('인증 대기중인 기업회원입니다.');
            return next('/auth/login');
        }
        if (reason === 'forbidden') {
            alert('접근 권한이 없습니다.');
            return next('/new/dashboard');
        }
    }

    return next();
});

// =========================================================
// ✅ afterEach: 로그인 페이지 이탈 시 세션스토리지 정리
// =========================================================
router.afterEach((to, from) => {
    if (from.path === '/auth/login') {
        // ✨ [수정 2] 도착하기도 전에 시리얼 키가 지워지는 현상을 막기 위해 아래 줄을 제거합니다.
        // sessionStorage.removeItem('originalSerialKey');

        sessionStorage.removeItem('preLoginRoute');
    }
});

export default router;
